import createMuiTheme from '@material-ui/core/styles/createMuiTheme';

declare module '@material-ui/core/styles/createBreakpoints' {
  interface BreakpointOverrides {
    xs: true;
    sm: true;
    md: true;
    lg: true;
    xl: true;
  }
}

export const colors = {
  background: '#f5f7f9',
  bluePrimary: '#0059da',
  paleGrey: '#f5f7f9',
  paleBlue: '#e1e7ed',
  lightGreyBlue: '#a8b4c1',
  dusk: '#3f5b77',
  darkIndigo: '#0a2642',
  navyShadow: 'rgba(0, 32, 64, 0.1)',
  green: '#1eb25e',
  teal: '#00ACC1',
  red: '#D20004',
};

export const boxShadows = {
  main: `0 10px 20px 0 ${colors.navyShadow}, 0 10px 5px -4px rgba(0, 32, 64, 0.07), inset 0 -1.5px 0 0 ${colors.paleBlue}`,
  input: `0 4px 12px 0 rgba(0, 89, 218, 0.2)`,
  bars: `0 0 10px 0 ${colors.navyShadow}`,
};

const theme = createMuiTheme({
  palette: {
    primary: {
      main: colors.bluePrimary,
    },
  },
  typography: {
    fontFamily:
      'proxima-nova, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
  },
  overrides: {
    MuiAppBar: {
      root: {
        boxShadow: boxShadows.bars,
      },
    },
    MuiToolbar: {
      root: {
        backgroundColor: 'white',
        color: colors.dusk,
      },
    },
    MuiFab: {
      root: {
        boxShadow: boxShadows.main,
        backgroundColor: 'white',
        color: colors.bluePrimary,
        '&:hover': {
          backgroundColor: 'white',
        },
      },
    },
    MuiButton: {
      containedPrimary: {
        color: 'white',
        fontSize: '16px',
        textTransform: 'none',
        padding: '8px 56px',
        borderRadius: '20px',
        fontWeight: 'bold',
        '&:disabled': {
          backgroundColor: colors.lightGreyBlue,
          color: 'white',
        },
      },
      text: {
        fontWeight: 'bold',
        fontSize: '16px',
        textTransform: 'none',
      },
    },
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 1024,
      lg: 1280,
      xl: 1920,
    },
  },
});

// eslint-disable-next-line import/no-default-export -- This code was written prior to enforcing lint rules
export default theme;
